<template>
  <div id="pagePlaner">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card class="planer-card elevation-2">
            <div class="planer-toolbar">
              <v-icon class="mr-2" color="white" size="20">mdi-calendar-month</v-icon>
              <span class="planer-toolbar__title">Planning</span>
              <v-spacer></v-spacer>

              <!-- Navegación de fechas -->
              <div class="planer-date-nav">
                <button class="planer-date-nav__btn" @click="prevRange">
                  <v-icon size="16">mdi-chevron-left</v-icon>
                </button>
                <span class="planer-date-nav__label">{{ dateRangeLabel }}</span>
                <button class="planer-date-nav__btn" @click="nextRange">
                  <v-icon size="16">mdi-chevron-right</v-icon>
                </button>
                <button class="planer-date-nav__today" @click="goToday">Hoy</button>
              </div>

              <!-- Toggle 10/15 días -->
              <div class="planer-range-toggle ml-3">
                <button
                  class="planer-range-toggle__btn planer-range-toggle__btn--left"
                  :class="{ 'planer-range-toggle__btn--active': rangeSize === 10 }"
                  @click="setRangeSize(10)"
                >10</button>
                <button
                  class="planer-range-toggle__btn planer-range-toggle__btn--right"
                  :class="{ 'planer-range-toggle__btn--active': rangeSize === 15 }"
                  @click="setRangeSize(15)"
                >15</button>
              </div>
            </div>

      <!-- FILTER BAR -->
      <div class="planer-filters">

        <!-- Ubicación -->
        <v-menu v-model="locationMenu" :close-on-content-click="false" offset-y min-width="210" z-index="50">
          <template #activator="{ on }">
            <button class="planer-filters__dropdown" v-on="on">
              <span>{{ locationLabel }}</span>
              <span v-if="selectedLocations.length > 1" class="planer-filters__badge">{{ selectedLocations.length }}</span>
              <v-icon size="13" class="ml-1">mdi-chevron-down</v-icon>
            </button>
          </template>
          <v-card elevation="2">
            <v-list dense class="py-1">
              <v-list-item
                v-for="loc in locationOptions"
                :key="loc"
                class="planer-filters__menu-item"
                @click="toggleLocation(loc)"
              >
                <v-list-item-action class="my-0 mr-2" style="min-width:24px">
                  <v-checkbox
                    :input-value="selectedLocations.includes(loc)"
                    dense hide-details color="primary"
                    class="ma-0 pa-0"
                    @click.stop="toggleLocation(loc)"
                  />
                </v-list-item-action>
                <v-list-item-title style="font-size:12px">{{ loc }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <!-- Destino de uso -->
        <!-- <v-menu v-model="destinationMenu" :close-on-content-click="false" offset-y min-width="230" z-index="50">
          <template #activator="{ on }">
            <button class="planer-filters__dropdown" v-on="on">
              <span>{{ destinationLabel }}</span>
              <span v-if="selectedDestinations.length > 1" class="planer-filters__badge">{{ selectedDestinations.length }}</span>
              <v-icon size="13" class="ml-1">mdi-chevron-down</v-icon>
            </button>
          </template>
          <v-card elevation="2">
            <v-list dense class="py-1">
              <v-list-item
                v-for="dest in destinationOptions"
                :key="dest"
                class="planer-filters__menu-item"
                @click="toggleDestination(dest)"
              >
                <v-list-item-action class="my-0 mr-2" style="min-width:24px">
                  <v-checkbox
                    :input-value="selectedDestinations.includes(dest)"
                    dense hide-details color="primary"
                    class="ma-0 pa-0"
                    @click.stop="toggleDestination(dest)"
                  />
                </v-list-item-action>
                <v-list-item-title style="font-size:12px">{{ dest }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu> -->

        <!-- Estado chips -->
        <div class="planer-filters__chip-group">
          <v-chip-group v-model="quickFilter" @change="applyQuickFilter">
            <v-chip filter outlined color="red" small>
              <v-icon left x-small>mdi-alert-circle-outline</v-icon>
              Sin reportar
            </v-chip>
            <v-chip filter outlined color="orange" small>
              <v-icon left x-small>mdi-bell-ring-outline</v-icon>
              Reportado
            </v-chip>
            <v-chip filter outlined color="purple" small>
              <v-icon left x-small>mdi-progress-clock</v-icon>
              En proceso
            </v-chip>
            <v-chip filter outlined color="green" small>
              <v-icon left x-small>mdi-check-circle-outline</v-icon>
              Completado
            </v-chip>
          </v-chip-group>
        </div>

        <!-- Búsqueda libre -->
        <div class="planer-filters__search">
          <v-icon size="14" color="#9E9E9E" class="planer-filters__search-icon">mdi-magnify</v-icon>
          <input
            v-model="searchQuery"
            class="planer-filters__search-input"
            placeholder="Buscar vehículo…"
          />
        </div>
      </div>

      <!-- LEGEND BAR -->
      <div class="planer-legend">
        <div class="planer-legend__item">
          <span class="planer-legend__dot" style="background:#F44336"></span>
          <span>Sin reportar</span>
        </div>
        <div class="planer-legend__item">
          <span class="planer-legend__dot" style="background:#FF9800"></span>
          <span>Reportado</span>
        </div>
        <div class="planer-legend__item">
          <span class="planer-legend__dot" style="background:#9C27B0"></span>
          <span>En proceso</span>
        </div>
        <div class="planer-legend__item">
          <span class="planer-legend__dot" style="background:#4CAF50"></span>
          <span>Completado</span>
        </div>
        <div class="planer-legend__sep"></div>
        <div class="planer-legend__item">
          <span class="planer-legend__type-badge planer-legend__type-badge--m">M</span>
          <span>Movimiento</span>
        </div>
        <div class="planer-legend__item">
          <span class="planer-legend__type-badge planer-legend__type-badge--c">C</span>
          <span>Cesión</span>
        </div>
        <div class="planer-legend__sep"></div>
        <div class="planer-legend__item">
          <v-icon size="12" color="#9E9E9E">mdi-clock-outline</v-icon>
          <span style="color:#9E9E9E;font-size:10px">8:00 – 21:00</span>
        </div>
      </div>

      <!-- GANTT GRID -->
      <div class="planer-grid" ref="gridScroll">

        <!-- Sticky header -->
        <div class="planer-grid__header">
          <div class="planer-grid__vehicle-header">Vehículo</div>
          <div class="planer-grid__days-header" :style="daysAreaStyle">
            <div
              v-for="(day, idx) in days"
              :key="idx"
              class="planer-grid__day-col"
              :class="{
                'planer-grid__day-col--today': isToday(day),
                'planer-grid__day-col--weekend': isWeekend(day),
                'planer-grid__day-col--expanded': idx === expandedIdx
              }"
              :style="getDayColStyle(idx)"
            >
              <div class="planer-grid__day-actions">
                <button
                  class="planer-grid__day-btn"
                  :title="idx === expandedIdx ? 'Contraer día' : 'Expandir día'"
                  @click.stop="toggleDayExpand(day)"
                >
                  <v-icon size="13">{{ idx === expandedIdx ? 'mdi-arrow-collapse-horizontal' : 'mdi-arrow-expand-horizontal' }}</v-icon>
                </button>
                <button
                  class="planer-grid__day-btn"
                  title="Ver detalle del día"
                  @click.stop="openDayDetail(day)"
                >
                  <v-icon size="13">mdi-format-list-bulleted</v-icon>
                </button>
              </div>
              <div class="planer-grid__day-top">
                <span class="planer-grid__day-num">{{ day.format('D') }}</span>
                <span class="planer-grid__day-name">{{ idx === expandedIdx ? day.format('dddd').toUpperCase() : day.format('ddd').toUpperCase() }}</span>
              </div>
              <div class="planer-grid__day-ticks">
                <div
                  v-for="tick in getHourTicks(idx)"
                  :key="tick.hour"
                  class="planer-grid__tick"
                  :class="{ 'planer-grid__tick--end': tick.pct > 85 }"
                  :style="{ left: tick.pct + '%' }"
                >
                  <span class="planer-grid__tick-label">{{ tick.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Vehicle rows -->
        <div
          v-for="vehicle in filteredVehicles"
          :key="vehicle.id"
          class="planer-grid__row"
        >
          <!-- Vehicle card -->
          <div class="planer-grid__vehicle-col">
            <div class="vc-name">{{ vehicle.name }}</div>
            <div class="vc-plate">{{ vehicle.plate }}</div>
            <div class="vc-location">
              <v-icon size="9" color="#9E9E9E">mdi-map-marker</v-icon>
              <span>{{ vehicle.location }}</span>
            </div>
            <div class="vc-badges">
              <!-- <span
                class="vc-badge"
                :class="vehicle.active ? 'vc-badge--active' : 'vc-badge--inactive'"
              >{{ vehicle.active ? 'Activo' : 'No activo' }}</span> -->
              <span v-if="vehicle.protected" class="vc-badge vc-badge--protected">Protegido</span>
              <span v-if="vehicle.destination && vehicle.destination !== 'Sin destino'" class="vc-badge vc-badge--destination">{{ vehicle.destination }}</span>
              <!-- <span v-if="vehicle.pendingIntervention" class="vc-badge vc-badge--pending">Pend. Intervención</span> -->
              <span v-if="vehicle.archived" class="vc-badge vc-badge--archived">Archivado</span>
            </div>
            <div v-if="hasVehicleActions(vehicle)" class="vc-actions">
              <button v-if="canMov(vehicle.raw)" class="vc-btn vc-btn--movement" @click="openTransportForm(vehicle)">Movimiento</button>
              <button v-if="canCesion(vehicle.raw)" class="vc-btn vc-btn--cession" @click="openAssignmentForm(vehicle)">Cesión</button>
              <button v-if="canRecepcionar(vehicle.raw)" class="vc-btn vc-btn--recepcionar" @click="openTransportFormRecepcionar(vehicle)">Recepcionar</button>
              <button v-if="canFreeVehicle(vehicle.raw)" class="vc-btn vc-btn--archive" @click="confirmFreeVehicle(vehicle)">Archivar</button>
            </div>
          </div>

          <!-- Days area with bars -->
          <div class="planer-grid__days-area" :style="daysAreaStyle">
            <!-- Day background columns -->
            <div
              v-for="(day, idx) in days"
              :key="'bg-' + idx"
              class="planer-grid__day-bg"
              :class="{
                'planer-grid__day-bg--today': isToday(day),
                'planer-grid__day-bg--weekend': isWeekend(day),
                'planer-grid__day-bg--expanded': idx === expandedIdx
              }"
              :style="{ left: dayLeftPct(idx) + '%', width: dayWidthPct(idx) + '%' }"
            ></div>

            <!-- Gantt bars -->
            <div
              v-for="seg in getVisibleSegments(vehicle)"
              :key="seg.id"
              class="planer-bar"
              :style="getBarStyle(seg)"
              @click="onBarClick(seg)"
            >
              <div
                class="planer-bar__type"
                :class="seg.type === 'M' ? 'planer-bar__type--m' : 'planer-bar__type--c'"
              >{{ seg.type }}</div>
              <span class="planer-bar__label">{{ seg.label }}</span>
              <span class="planer-bar__time">{{ seg.startTime }}–{{ seg.endTime }}</span>
              <div
                v-if="seg.hasNextConsecutive"
                class="planer-bar__connector"
              ><v-icon size="12" color="rgba(255,255,255,0.7)">mdi-chevron-double-right</v-icon></div>
              <button
                v-if="seg.status === 'sin_reportar'"
                class="planer-bar__check"
                @click.stop="markAsReported(seg)"
              >
                <v-icon size="9" color="#2E7D32">mdi-check</v-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Empty state -->
        <div v-if="filteredVehicles.length === 0 && !loading" class="planer-grid__empty">
          <v-icon size="40" color="#E0E0E0">mdi-car-off</v-icon>
          <p>No se encontraron vehículos</p>
        </div>

        <!-- Load-more indicator removed, using pagination instead -->
      </div>

      <!-- PAGINATION ROW -->
      <div v-if="totalVehicles > 0" class="planer-pagination">
        <div class="planer-pagination__left">
          <span class="planer-pagination__label">Filas por página:</span>
          <v-select
            v-model="perPage"
            :items="[10, 20, 30, 40, 50]"
            dense
            outlined
            hide-details
            class="planer-pagination__select"
            @change="onPerPageChange"
          ></v-select>
        </div>
        <v-pagination
          v-if="totalPages > 1"
          v-model="currentPage"
          :length="totalPages"
          :total-visible="7"
          circle
          class="planer-pagination__component"
          @input="loadVehicles"
        ></v-pagination>
        <span class="planer-pagination__info">{{ paginationText }}</span>
      </div>

      <!-- STATS BAR -->
      <div class="planer-stats">
        <span class="planer-stats__item">
          <strong>{{ totalVehicles }}</strong>&nbsp;vehículos
        </span>
        <span class="planer-stats__sep"></span>
        <span class="planer-stats__item">
          <span class="planer-stats__dot" style="background:#F44336"></span>
          <strong>{{ barStats.sinReportar }}</strong>&nbsp;sin reportar
        </span>
        <span class="planer-stats__item">
          <span class="planer-stats__dot" style="background:#FF9800"></span>
          <strong>{{ barStats.reportado }}</strong>&nbsp;reportado
        </span>
        <span class="planer-stats__item">
          <span class="planer-stats__dot" style="background:#9C27B0"></span>
          <strong>{{ barStats.enProceso }}</strong>&nbsp;en proceso
        </span>
        <span class="planer-stats__item">
          <span class="planer-stats__dot" style="background:#4CAF50"></span>
          <strong>{{ barStats.completado }}</strong>&nbsp;completado
        </span>
      </div>

          </v-card>
        </v-col>
      </v-row>

      <!-- Movement Detail Dialog -->
      <v-dialog v-model="detailDialog" max-width="400" @click:outside="detailDialog = false">
        <v-card v-if="selectedSeg" class="planer-detail">
          <div class="planer-detail__header" :style="{ background: getStatusColor(selectedSeg.status) }">
            <div class="planer-detail__header-left">
              <span
                class="planer-detail__type-badge"
                :class="selectedSeg.type === 'M' ? 'planer-detail__type-badge--m' : 'planer-detail__type-badge--c'"
              >{{ selectedSeg.type }}</span>
              <div>
                <div class="planer-detail__header-label">{{ selectedSeg.label }}</div>
                <div class="planer-detail__header-vehicle">{{ selectedSeg.vehicleName }}</div>
              </div>
            </div>
            <div class="d-flex align-center">
              <v-btn
                v-if="selectedSeg.status !== 'completado' && canEditSeg(selectedSeg)"
                icon x-small class="mr-1"
                :disabled="loadingEdit"
                :loading="loadingEdit"
                @click="editSelectedSeg"
              >
                <v-icon color="white" size="18">mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon x-small @click="detailDialog = false">
                <v-icon color="white" size="18">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          <v-card-text class="pa-4">
            <div class="planer-detail__rows">
              <div class="planer-detail__row">
                <v-icon size="15" color="#9E9E9E">mdi-flag-outline</v-icon>
                <span class="planer-detail__row-label">Estado</span>
                <span class="planer-detail__row-value" :style="{ color: getStatusColor(selectedSeg.status), fontWeight: 600 }">{{ statusLabel(selectedSeg.status) }}</span>
              </div>
              <div class="planer-detail__row">
                <v-icon size="15" color="#9E9E9E">mdi-card-text-outline</v-icon>
                <span class="planer-detail__row-label">Matrícula</span>
                <span class="planer-detail__row-value">{{ selectedSeg.vehiclePlate || '—' }}</span>
              </div>
              <div class="planer-detail__row">
                <v-icon size="15" color="#9E9E9E">mdi-calendar-arrow-right</v-icon>
                <span class="planer-detail__row-label">Inicio</span>
                <span class="planer-detail__row-value">{{ formatDetailDate(selectedSeg.startDate) }} · {{ selectedSeg.startTime }}</span>
              </div>
              <div class="planer-detail__row">
                <v-icon size="15" color="#9E9E9E">mdi-calendar-arrow-left</v-icon>
                <span class="planer-detail__row-label">Devolución</span>
                <span class="planer-detail__row-value">{{ formatDetailDate(selectedSeg.endDate) }} · {{ selectedSeg.endTime }}</span>
              </div>
              <div class="planer-detail__row">
                <v-icon size="15" color="#9E9E9E">mdi-truck-outline</v-icon>
                <span class="planer-detail__row-label">Transporte</span>
                <span class="planer-detail__row-value">{{ transportLabel(selectedSeg.transportation) }}</span>
              </div>
              <div v-if="selectedSeg.observations" class="planer-detail__row planer-detail__row--obs">
                <v-icon size="15" color="#9E9E9E">mdi-note-text-outline</v-icon>
                <span class="planer-detail__row-label">Observaciones</span>
                <span class="planer-detail__row-value planer-detail__row-value--obs">{{ selectedSeg.observations }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Day Detail Dialog -->
      <v-dialog v-model="dayDialog" max-width="560" scrollable>
        <v-card v-if="selectedDay" class="planer-day-detail">
          <div class="planer-day-detail__header">
            <div class="planer-day-detail__header-left">
              <v-icon color="white" size="20" class="mr-2">mdi-calendar-today</v-icon>
              <div>
                <div class="planer-day-detail__title">{{ dayDialogTitle }}</div>
                <div class="planer-day-detail__subtitle">{{ dayDetailSegments.length }} {{ dayDetailSegments.length === 1 ? 'movimiento' : 'movimientos' }}</div>
              </div>
            </div>
            <v-btn icon x-small @click="dayDialog = false">
              <v-icon color="white" size="18">mdi-close</v-icon>
            </v-btn>
          </div>

          <!-- Resumen por estado -->
          <div v-if="dayDetailSegments.length" class="planer-day-detail__stats">
            <span v-for="stat in dayDetailStats" :key="stat.status" class="planer-day-detail__stat">
              <span class="planer-day-detail__stat-dot" :style="{ background: getStatusColor(stat.status) }"></span>
              <strong>{{ stat.count }}</strong>&nbsp;{{ statusLabel(stat.status).toLowerCase() }}
            </span>
          </div>

          <v-card-text class="pa-0">
            <div v-if="dayDetailSegments.length === 0" class="planer-day-detail__empty">
              <v-icon size="36" color="#E0E0E0">mdi-calendar-blank-outline</v-icon>
              <p>No hay movimientos este día</p>
            </div>

            <div
              v-for="seg in dayDetailSegments"
              :key="seg.id"
              class="planer-day-detail__item"
              @click="onBarClick(seg)"
            >
              <span class="planer-day-detail__item-bar" :style="{ background: getStatusColor(seg.status) }"></span>
              <span
                class="planer-day-detail__item-type"
                :class="seg.type === 'M' ? 'planer-day-detail__item-type--m' : 'planer-day-detail__item-type--c'"
              >{{ seg.type }}</span>
              <div class="planer-day-detail__item-info">
                <div class="planer-day-detail__item-vehicle">
                  {{ seg.vehicleName }}
                  <span class="planer-day-detail__item-plate">{{ seg.vehiclePlate }}</span>
                </div>
                <div class="planer-day-detail__item-time">
                  <v-icon size="12" color="#9E9E9E">mdi-clock-outline</v-icon>
                  {{ segDayTimeLabel(seg) }}
                  <span v-if="seg.transportation" class="planer-day-detail__item-transport">· {{ transportLabel(seg.transportation) }}</span>
                </div>
              </div>
              <span class="planer-day-detail__item-status" :style="{ color: getStatusColor(seg.status) }">{{ statusLabel(seg.status) }}</span>
              <v-icon size="16" color="#BDBDBD">mdi-chevron-right</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Edit forms -->
      <movimiento-form
        v-if="visibleMovimientoForm && editItem && editItem.type !== 'assignment'"
        v-model="editItem"
        @save="saveMovimiento"
        @cancel="visibleMovimientoForm = false"
      ></movimiento-form>
      <cesion-form
        v-if="visibleMovimientoForm && editItem && editItem.type === 'assignment'"
        v-model="editItem"
        @save="saveMovimiento"
        @cancel="visibleMovimientoForm = false"
      ></cesion-form>

      <!-- Crear movimiento / cesión (mismo componente que VehiculoDetail.vue) -->
      <transport-form
        v-if="selectedVehicleForTransport"
        :visible="transportFormVisible"
        :status="selectedVehicleForTransport"
        :is-assignment="isAssignmentMode"
        :is-movement="isMovementMode"
        :is-recepcionar="isRecepcionarMode"
        no-redirect
        @close="closeTransportForm"
        @submit="handleTransportSubmit"
        @reload-with-movement="handleReloadWithMovement"
      ></transport-form>

      <!-- Diálogo de confirmación para Archivar vehículo -->
      <v-dialog v-model="freeVehicleDialog" max-width="400">
        <v-card>
          <v-card-title class="warning--text">
            <v-icon left color="warning">mdi-lock-open</v-icon>
            Archivar vehículo
          </v-card-title>
          <v-card-text>
            ¿Está seguro que desea archivar este vehículo?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="freeVehicleDialog = false">Cancelar</v-btn>
            <v-btn color="warning" @click="freeVehicle" :loading="freeVehicleLoading">Archivar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import 'moment/locale/es'
import { mapGetters } from 'vuex'
import VehiculoService from '@/services/VehiculoService'
import MovimientoService from '@/services/MovimientoService'
import LocationService from '@/services/LocationService'

moment.locale('es')

const MONTH_ES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

const FILTERS_STORAGE_KEY = 'planner.filters'

const STATUS_COLORS = {
  sin_reportar: '#F44336',
  reportado: '#FF9800',
  en_proceso: '#9C27B0',
  completado: '#4CAF50'
}

const MOVEMENT_STATUS_MAP = {
  unreported: 'sin_reportar',
  reported: 'reportado',
  transport: 'en_proceso',
  processing: 'en_proceso',
  in_process: 'en_proceso',
  completed: 'completado'
}

export default {
  name: 'Planer',

  components: {
    MovimientoForm: () => import('@/views/movimiento/MovimientoForm'),
    CesionForm: () => import('@/views/cesion/CesionForm'),
    TransportForm: () => import('@/components/TransportForm')
  },

  data () {
    return {
      // Navigation
      offset: 0,
      rangeSize: 10,

      // Vehicle data loaded from API
      loading: false,
      currentPage: 1,
      totalPages: 1,
      totalVehicles: 0,
      perPage: 20,
      vehicles: [],
      segments: [],

      // Detail dialog
      detailDialog: false,
      selectedSeg: null,

      // Day detail dialog
      dayDialog: false,
      selectedDay: null,

      // Día expandido inline (fecha 'YYYY-MM-DD' o null)
      expandedDay: null,

      // Edit form
      visibleMovimientoForm: false,
      editItem: null,
      loadingEdit: false,

      // Transport form (crear movimiento / cesión)
      transportFormVisible: false,
      selectedVehicleForTransport: null,
      isAssignmentMode: false,
      isMovementMode: false,
      isRecepcionarMode: false,

      // Archivar vehículo
      freeVehicleDialog: false,
      freeVehicleLoading: false,
      vehicleToFree: null,

      // Filters
      locationMenu: false,
      destinationMenu: false,
      selectedLocations: [],
      selectedDestinations: [],
      filterActive: false,
      filterInactive: false,
      filterProtected: 'Todos',
      searchQuery: '',
      quickFilter: null,
      filterStatus: null,

      // Nav items
      topNavItems: [
        { id: 'vehiculos', label: 'Vehículos', icon: 'mdi-car' },
        { id: 'movimientos', label: 'Movimientos', icon: 'mdi-road-variant' },
        { id: 'cesiones', label: 'Cesiones', icon: 'mdi-clipboard-list-outline' },
        { id: 'danos', label: 'Daños', icon: 'mdi-car-wrench' },
        { id: 'planning', label: 'Planning', icon: 'mdi-calendar-month' }
      ],
      bottomNavItems: [
        { id: 'usuarios', label: 'Usuarios', icon: 'mdi-account-group' },
        { id: 'configuracion', label: 'Configuración', icon: 'mdi-cog' }
      ]
    }
  },

  computed: {
    filterState () {
      return {
        selectedLocations: this.selectedLocations,
        selectedDestinations: this.selectedDestinations,
        filterActive: this.filterActive,
        filterInactive: this.filterInactive,
        filterProtected: this.filterProtected,
        searchQuery: this.searchQuery,
        quickFilter: this.quickFilter,
        filterStatus: this.filterStatus
      }
    },

    today () {
      return moment().startOf('day')
    },

    windowStart () {
      return this.today.clone().add(this.offset, 'days')
    },

    days () {
      return Array.from({ length: this.rangeSize }, (_, i) =>
        this.windowStart.clone().add(i, 'days')
      )
    },

    dateRangeLabel () {
      const start = this.days[0]
      const end = this.days[this.days.length - 1]
      const startStr = `${start.date()} ${MONTH_ES[start.month()]}`
      const endStr = `${end.date()} ${MONTH_ES[end.month()]} ${end.year()}`
      return `${startStr} — ${endStr}`
    },

    hourTicks () {
      // Displayed at 8, 12, 16, 20 within each day column (8:00–21:00 = 780 min)
      return [8, 12, 16, 20].map(h => ({
        hour: h,
        pct: ((h - 8) / 13) * 100,
        label: `${h}h`
      }))
    },

    expandedHourTicks () {
      // Cada hora de 8 a 20 para el día expandido
      return Array.from({ length: 13 }, (_, i) => 8 + i).map(h => ({
        hour: h,
        pct: ((h - 8) / 13) * 100,
        label: `${h}h`
      }))
    },

    ...mapGetters(['LOCATIONS', 'HAS_PERMISSION', 'CURRENT_USER']),

    locationOptions () {
      const names = (this.LOCATIONS || []).map(l => l.name).filter(Boolean)
      return [...new Set(names)].sort()
    },

    destinationOptions () {
      return ['Test Drive VN/VO', 'Sustitución taller', 'Uso interno', 'Uso externo', 'Sin destino']
    },

    locationLabel () {
      if (this.selectedLocations.length === 0) return 'Ubicación'
      if (this.selectedLocations.length === 1) return this.selectedLocations[0]
      return 'Ubicación'
    },

    destinationLabel () {
      if (this.selectedDestinations.length === 0) return 'Destino de uso'
      if (this.selectedDestinations.length === 1) return this.selectedDestinations[0]
      return 'Destino de uso'
    },

    filteredVehicles () {
      return this.vehicles.filter(v => {
        if (this.selectedLocations.length > 0 && !this.selectedLocations.includes(v.location)) return false
        if (this.selectedDestinations.length > 0 && !this.selectedDestinations.includes(v.destination)) return false
        if (this.filterActive && !v.active) return false
        if (this.filterInactive && v.active) return false
        if (this.filterProtected === 'Sí' && !v.protected) return false
        if (this.filterProtected === 'No' && v.protected) return false
        if (this.searchQuery.trim()) {
          const q = this.searchQuery.trim().toLowerCase()
          if (!v.name.toLowerCase().includes(q) && !v.plate.toLowerCase().includes(q)) return false
        }
        if (this.filterStatus) {
          const vehicleSegments = this.visibleSegments.filter(s => s.vehicleId === v.id)
          if (!vehicleSegments.some(s => s.status === this.filterStatus)) return false
        }
        return true
      })
    },

    activeVehicleCount () {
      return this.filteredVehicles.filter(v => v.active).length
    },

    inactiveVehicleCount () {
      return this.filteredVehicles.filter(v => !v.active).length
    },

    visibleSegments () {
      const windowEnd = this.days[this.days.length - 1].clone().endOf('day')
      const windowStartDay = this.windowStart
      return this.segments.filter(seg => {
        const start = moment(seg.startDate)
        const end = moment(seg.endDate)
        return start.isBefore(windowEnd) && end.isAfter(windowStartDay.clone().subtract(1, 'day'))
      })
    },

    dayColStyle () {
      return { flex: `0 0 ${100 / this.rangeSize}%`, minWidth: '240px' }
    },

    daysAreaStyle () {
      return { minWidth: (this.totalDayUnits * 240) + 'px' }
    },

    // Índice del día expandido dentro de la ventana visible (-1 si no hay)
    expandedIdx () {
      if (!this.expandedDay) return -1
      return this.days.findIndex(d => d.format('YYYY-MM-DD') === this.expandedDay)
    },

    // Peso total de columnas: el día expandido ocupa 3 unidades
    totalDayUnits () {
      return this.expandedIdx >= 0 ? this.rangeSize + 2 : this.rangeSize
    },

    paginationText () {
      if (this.totalVehicles === 0) return ''
      const start = (this.currentPage - 1) * this.perPage + 1
      const end = Math.min(start + this.perPage - 1, this.totalVehicles)
      return `${start}-${end} de ${this.totalVehicles}`
    },

    barStats () {
      const segs = this.visibleSegments.filter(seg =>
        this.filteredVehicles.some(v => v.id === seg.vehicleId)
      )
      return {
        sinReportar: segs.filter(s => s.status === 'sin_reportar').length,
        reportado: segs.filter(s => s.status === 'reportado').length,
        enProceso: segs.filter(s => s.status === 'en_proceso').length,
        completado: segs.filter(s => s.status === 'completado').length
      }
    },

    dayDialogTitle () {
      if (!this.selectedDay) return ''
      const label = this.selectedDay.format('dddd, D [de] MMMM [de] YYYY')
      return label.charAt(0).toUpperCase() + label.slice(1)
    },

    dayDetailSegments () {
      if (!this.selectedDay) return []
      const dayStart = this.selectedDay.clone().startOf('day')
      const dayEnd = this.selectedDay.clone().endOf('day')
      const vehicleIds = new Set(this.filteredVehicles.map(v => v.id))
      return this.segments
        .filter(seg => vehicleIds.has(seg.vehicleId))
        .filter(seg => {
          const start = moment(`${seg.startDate} ${seg.startTime}`, 'YYYY-MM-DD HH:mm')
          const end = moment(`${seg.endDate} ${seg.endTime}`, 'YYYY-MM-DD HH:mm')
          return start.isSameOrBefore(dayEnd) && end.isSameOrAfter(dayStart)
        })
        .sort((a, b) => {
          const aStart = moment(`${a.startDate} ${a.startTime}`, 'YYYY-MM-DD HH:mm')
          const bStart = moment(`${b.startDate} ${b.startTime}`, 'YYYY-MM-DD HH:mm')
          return aStart - bStart
        })
    },

    dayDetailStats () {
      const order = ['sin_reportar', 'reportado', 'en_proceso', 'completado']
      return order
        .map(status => ({ status, count: this.dayDetailSegments.filter(s => s.status === status).length }))
        .filter(s => s.count > 0)
    }
  },

  methods: {
    async loadVehicles () {
      this.loading = true
      try {
        const { data } = await VehiculoService.get({ page: this.currentPage, 'per-page': this.perPage, 'filter[planning]': 1 })
        this.totalPages = data._meta?.pageCount || 1
        this.totalVehicles = data._meta?.totalCount || 0
        const apiVehicles = data.data || []
        this.vehicles = apiVehicles.map(v => this._mapVehicle(v))
        this.segments = apiVehicles.flatMap(v => this._mapSegments(v))
        // Scroll grid back to top on page change
        if (this.$refs.gridScroll) this.$refs.gridScroll.scrollTop = 0
      } catch (e) {
        this.$toast.error('Error al cargar los vehículos')
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    onPerPageChange (perPage) {
      this.perPage = perPage
      this.currentPage = 1
      this.loadVehicles()
    },

    async loadMoreVehicles () {},

    _mapVehicle (v) {
      const nameParts = [v.brand, v.model].filter(Boolean).join(' ')
      return {
        id: v.id,
        raw: v,
        dealerId: v.dealer ? v.dealer.id : (v.dealer_id || null),
        name: nameParts || v.plate_number || v.iic_number || `Vehículo #${v.id}`,
        plate: v.plate_number || v.iic_number || '',
        location: v.location ? v.location.name : 'Sin ubicación',
        active: ['registered', 'delivered'].includes(v.status),
        protected: false,
        destination: 'Sin destino',
        // pendingIntervention: Array.isArray(v.todos) && v.todos.some(t => t.status !== 'completed'),
        archived: v.status === 'free'
      }
    },

    _mapSegments (v) {
      const vName = [v.brand, v.model].filter(Boolean).join(' ') || v.plate_number || v.iic_number || `Vehículo #${v.id}`
      return (v.movements || [])
        .map(m => {
          const start = moment.unix(m.delivery_date ? m.delivery_date : m.datetime)
          // Al completar el movimiento/cesión, el final de la línea de tiempo
          // es la devolución REAL (reception_datetime). Mientras no se complete,
          // usamos end_date (estimada). updated_at es el fallback por si un
          // movimiento viejo quedó completado sin reception_datetime.
          const end = m.status === 'completed'
            ? moment.unix(m.reception_datetime || m.updated_at).tz('Europe/Madrid')
            : (m.end_date ? moment.unix(m.end_date).tz('Europe/Madrid') : start.clone().add(2, 'hours'))
          return {
            id: m.id,
            vehicleId: v.id,
            vehicleDealerId: v.dealer ? v.dealer.id : (v.dealer_id || null),
            type: m.type === 'assignment' ? 'C' : 'M',
            status: MOVEMENT_STATUS_MAP[m.status] || 'sin_reportar',
            startDate: start.format('YYYY-MM-DD'),
            startTime: start.format('HH:mm'),
            endDate: end.format('YYYY-MM-DD'),
            endTime: end.format('HH:mm'),
            label: this.statusLabel(MOVEMENT_STATUS_MAP[m.status] || 'sin_reportar'),
            vehicleName: vName,
            vehiclePlate: v.plate_number || v.iic_number || '',
            transportation: m.transportation || null,
            observations: m.observations || null
          }
        })
    },

    onGridScroll () {},

    prevRange () { this.offset -= this.rangeSize },
    nextRange () { this.offset += this.rangeSize },
    goToday () { this.offset = 0 },
    setRangeSize (size) { this.rangeSize = size },

    isToday (day) { return day.isSame(moment(), 'day') },
    isWeekend (day) { return day.day() === 0 || day.day() === 6 },

    toggleLocation (loc) {
      const idx = this.selectedLocations.indexOf(loc)
      if (idx === -1) this.selectedLocations.push(loc)
      else this.selectedLocations.splice(idx, 1)
    },

    toggleDestination (dest) {
      const idx = this.selectedDestinations.indexOf(dest)
      if (idx === -1) this.selectedDestinations.push(dest)
      else this.selectedDestinations.splice(idx, 1)
    },

    applyQuickFilter (index) {
      if (index === null || index === undefined) {
        this.filterStatus = null
      } else {
        const statusValues = ['sin_reportar', 'reportado', 'en_proceso', 'completado']
        this.filterStatus = statusValues[index]
      }
    },

    getVisibleSegments (vehicle) {
      const segs = this.visibleSegments
        .filter(s => s.vehicleId === vehicle.id)
        .sort((a, b) => a.startDate.localeCompare(b.startDate) || a.startTime.localeCompare(b.startTime))
      for (let i = 0; i < segs.length - 1; i++) {
        const cur = segs[i]
        const next = segs[i + 1]
        const curEnd = moment(`${cur.endDate} ${cur.endTime}`, 'YYYY-MM-DD HH:mm')
        const nextStart = moment(`${next.startDate} ${next.startTime}`, 'YYYY-MM-DD HH:mm')
        cur.hasNextConsecutive = nextStart.diff(curEnd, 'minutes') <= 5 && nextStart.diff(curEnd, 'minutes') >= 0
      }
      return segs
    },

    // ── Día expandido inline ──
    toggleDayExpand (day) {
      const key = day.format('YYYY-MM-DD')
      this.expandedDay = this.expandedDay === key ? null : key
    },

    // Unidades de ancho de cada día (el expandido ocupa 3)
    dayUnits (idx) {
      return idx === this.expandedIdx ? 3 : 1
    },

    dayLeftPct (idx) {
      const unit = 100 / this.totalDayUnits
      let units = idx
      if (this.expandedIdx >= 0 && idx > this.expandedIdx) units += 2
      return units * unit
    },

    dayWidthPct (idx) {
      return this.dayUnits(idx) * (100 / this.totalDayUnits)
    },

    getDayColStyle (idx) {
      return {
        flex: `0 0 ${this.dayWidthPct(idx)}%`,
        minWidth: (this.dayUnits(idx) * 240) + 'px'
      }
    },

    getHourTicks (idx) {
      return idx === this.expandedIdx ? this.expandedHourTicks : this.hourTicks
    },

    // ¿El segmento pasa por el día expandido?
    segTouchesExpandedDay (seg) {
      if (!this.expandedDay) return false
      return seg.startDate <= this.expandedDay && seg.endDate >= this.expandedDay
    },

    // Posición en % de (día + fracción horaria) considerando el día expandido
    dayPosPct (dayIdx, frac) {
      const unit = 100 / this.totalDayUnits
      if (dayIdx < 0) return (dayIdx + frac) * unit
      if (dayIdx >= this.rangeSize) {
        const extra = this.expandedIdx >= 0 ? 2 : 0
        return (this.rangeSize + extra + (dayIdx - this.rangeSize) + frac) * unit
      }
      return this.dayLeftPct(dayIdx) + frac * this.dayWidthPct(dayIdx)
    },

    getBarStyle (seg) {
      const windowStartDay = this.windowStart.clone().startOf('day')

      const parseFrac = (timeStr) => {
        const [h, m] = timeStr.split(':').map(Number)
        return Math.max(0, Math.min(1, ((h - 8) * 60 + m) / 780))
      }

      const startDay = moment(seg.startDate).startOf('day').diff(windowStartDay, 'days')
      const endDay = moment(seg.endDate).startOf('day').diff(windowStartDay, 'days')

      const left = this.dayPosPct(startDay, parseFrac(seg.startTime))
      const right = this.dayPosPct(endDay, parseFrac(seg.endTime))
      const width = right - left

      if (left >= 100 || right <= 0) return { display: 'none' }

      return {
        left: `${left}%`,
        width: `${Math.max(0.8, width)}%`,
        backgroundColor: STATUS_COLORS[seg.status] || '#9E9E9E'
      }
    },

    getStatusColor (status) {
      return STATUS_COLORS[status] || '#9E9E9E'
    },

    async markAsReported (seg) {
      try {
        const response = await MovimientoService.aceptarMovimiento(seg.id)
        if (response.error) {
          this.$toast.error('Ocurrió un error al aceptar el movimiento')
          return
        }
        this.$toast.success('Movimiento aceptado correctamente')
        await this.loadVehicles()
      } catch (error) {
        console.error('Error al aceptar el movimiento:', error)
        this.$toast.error('Ocurrió un error al aceptar el movimiento')
      }
    },

    onBarClick (seg) {
      this.selectedSeg = seg
      this.detailDialog = true
    },

    /**
     * Misma lógica que Movimiento.vue → canEditMovimiento:
     * - Colaborador: solo movimientos (no sin reportar) de su propio dealer
     * - Vehículo de un dealer partner: verifica permiso cruzado 'editar_movimiento'
     * - Vehículo del dealer propio: verifica permiso local 'editar_movimiento'
     */
    canEditSeg (seg) {
      if (!seg) return false

      const vehicleDealerId = seg.vehicleDealerId
      const myDealerId = this.CURRENT_USER?.dealer?.id

      // Colaborador: solo movimientos de su propio dealer
      if (this.$store.getters.HAS_ROLE(['colaborator'])) {
        if (!myDealerId) return false
        return seg.status !== 'sin_reportar' && vehicleDealerId === myDealerId
      }

      // Vehículo de un dealer partner: SOLO permiso cruzado
      if (vehicleDealerId && myDealerId && vehicleDealerId !== myDealerId) {
        return this.$store.getters.HAS_PARTNER_PERMISSION({
          dealerId: vehicleDealerId,
          permission: 'editar_movimiento'
        })
      }

      // Vehículo del dealer propio: permiso local
      return this.HAS_PERMISSION('editar_movimiento')
    },

    async editSelectedSeg () {
      this.loadingEdit = true
      try {
        const { data } = await MovimientoService.view({ id: this.selectedSeg.id })
        this.editItem = data.data
        this.detailDialog = false
        this.visibleMovimientoForm = true
      } catch (error) {
        console.error('Error al cargar el movimiento:', error)
        this.$toast.error('Error al cargar los datos del movimiento')
      } finally {
        this.loadingEdit = false
      }
    },

    saveMovimiento () {
      this.visibleMovimientoForm = false
      this.editItem = null
      this.$toast.success('Movimiento actualizado con éxito')
      this.loadVehicles()
    },

    openTransportForm (vehicle) {
      this.selectedVehicleForTransport = vehicle.raw
      this.isAssignmentMode = false
      this.isMovementMode = true
      this.isRecepcionarMode = false
      this.transportFormVisible = true
    },

    openAssignmentForm (vehicle) {
      this.selectedVehicleForTransport = vehicle.raw
      this.isAssignmentMode = true
      this.isMovementMode = false
      this.isRecepcionarMode = false
      this.transportFormVisible = true
    },

    openTransportFormRecepcionar (vehicle) {
      this.selectedVehicleForTransport = vehicle.raw
      this.isAssignmentMode = false
      this.isMovementMode = false
      this.isRecepcionarMode = true
      this.transportFormVisible = true
    },

    // ── Condiciones de acciones según estado (misma lógica que VehiculoDetail.vue) ──
    hasVehicleActions (vehicle) {
      const v = vehicle.raw
      return this.canMov(v) || this.canCesion(v) || this.canRecepcionar(v) || this.canFreeVehicle(v)
    },

    canMov (vehicle) {
      if (!vehicle || vehicle.status === 'free' || !(vehicle.movements || []).length) return false
      if (vehicle.status !== 'registered') return false

      // Si es colaborador, puede crear movimientos sin restricción de dealer
      if (this.$store.getters.HAS_ROLE(['colaborator'])) return true

      // Permiso directo o partner sobre el dealer del vehículo
      const dealerId = vehicle.dealer?.id
      const myDealerId = this.CURRENT_USER?.dealer?.id
      if (dealerId === myDealerId) return true
      if (dealerId && dealerId !== myDealerId && this.$store.getters.HAS_PARTNER_PERMISSION({ permission: 'crear_movimiento', dealerId })) return true
      return false
    },

    canCesion (vehicle) {
      if (!vehicle || vehicle.status === 'free' || !(vehicle.movements || []).length) return false
      if (vehicle.status !== 'registered') return false

      // Si es colaborador, puede crear cesiones sin restricción de dealer
      if (this.$store.getters.HAS_ROLE(['colaborator'])) return true

      const dealerId = vehicle.dealer?.id
      const myDealerId = this.CURRENT_USER?.dealer?.id
      if (this.HAS_PERMISSION('crear_cesion') && dealerId === myDealerId) return true
      if (dealerId && dealerId !== myDealerId && this.$store.getters.HAS_PARTNER_PERMISSION({ permission: 'crear_cesion', dealerId })) return true
      return false
    },

    canRecepcionar (vehicle) {
      if (!vehicle) return false

      // Solo se puede recepcionar si el estado lo permite
      const canRecepcionarByStatus = vehicle.status === 'created' || vehicle.status === 'free'
      if (!canRecepcionarByStatus) return false

      // Si es colaborador, puede recepcionar sin restricción de dealer
      if (this.$store.getters.HAS_ROLE(['colaborator'])) return true

      const dealerId = vehicle.dealer?.id
      const myDealerId = this.CURRENT_USER?.dealer?.id
      if (dealerId === myDealerId) return true
      if (dealerId && dealerId !== myDealerId && this.$store.getters.IS_PARTNER) return true
      return false
    },

    canFreeVehicle (vehicle) {
      if (!vehicle) return false
      if (vehicle.status === 'free') return false
      if (!vehicle.movements || vehicle.movements.length === 0) return false

      // Último movimiento
      const sortedMovements = [...vehicle.movements].sort(
        (a, b) => new Date(b.datetime) - new Date(a.datetime)
      )
      const lastMovement = sortedMovements[0]

      const canFreeByMovementStatus = (lastMovement.type === 'exit' && lastMovement.status === 'completed') ||
        (lastMovement.type === 'assignment' && lastMovement.status === 'completed') ||
        (lastMovement.type === 'entry' && lastMovement.status === 'completed')
      if (!canFreeByMovementStatus) return false

      const dealerId = vehicle.dealer?.id
      const myDealerId = this.CURRENT_USER?.dealer?.id
      if (this.HAS_PERMISSION('editar_vehiculo') && dealerId === myDealerId) return true
      if (dealerId && dealerId !== myDealerId && this.$store.getters.HAS_PARTNER_PERMISSION({ permission: 'editar_vehiculo', dealerId })) return true
      return false
    },

    confirmFreeVehicle (vehicle) {
      this.vehicleToFree = vehicle.raw
      this.freeVehicleDialog = true
    },

    async freeVehicle () {
      if (!this.vehicleToFree) return
      try {
        this.freeVehicleLoading = true
        await VehiculoService.put({ id: this.vehicleToFree.id, status: 'free' })
        this.freeVehicleDialog = false
        this.vehicleToFree = null
        this.$toast.success('Vehículo liberado con éxito')
        await this.loadVehicles()
      } catch (error) {
        console.error('Error al liberar el vehículo:', error)
        this.$toast.error('Error al liberar el vehículo')
      } finally {
        this.freeVehicleLoading = false
      }
    },

    closeTransportForm () {
      this.transportFormVisible = false
      this.selectedVehicleForTransport = null
      this.isAssignmentMode = false
      this.isMovementMode = false
      this.isRecepcionarMode = false
    },

    handleTransportSubmit () {
      this.transportFormVisible = false
      this.selectedVehicleForTransport = null
      this.isAssignmentMode = false
      this.isMovementMode = false
      this.isRecepcionarMode = false
      this.$toast.success('Petición de movimiento creada con éxito')
      this.loadVehicles()
    },

    handleReloadWithMovement (payload) {
      // Actualizar el vehículo seleccionado con los datos actualizados
      this.selectedVehicleForTransport = payload.vehicle
      // Mantener el formulario abierto pero resetear los modos
      this.isAssignmentMode = false
      this.isMovementMode = false
      this.isRecepcionarMode = false
    },

    statusLabel (status) {
      return { sin_reportar: 'Sin reportar', reportado: 'Reportado', en_proceso: 'En proceso', completado: 'Completado' }[status] || status
    },

    transportLabel (transport) {
      return { DRIVER: 'Conductor', GRUA: 'Grúa', 'YO MISMO': 'Yo mismo' }[transport] || transport || '—'
    },

    async loadLocations () {
      try {
        const hasPartners = this.$store.getters.IS_PARTNER
        if (hasPartners) {
          const response = await LocationService.getPartnerLocations()
          const locations = response.data?.data?.locations || []
          this.$store.commit('SET_LOCATIONS', locations)
        } else {
          await this.$store.dispatch('LOAD_ALL_LOCATIONS')
        }
      } catch (error) {
        console.error('Error al cargar ubicaciones:', error)
      }
    },

    formatDetailDate (dateStr) {
      return moment(dateStr).format('D MMM YYYY')
    },

    openDayDetail (day) {
      this.selectedDay = day.clone()
      this.dayDialog = true
    },

    segDayTimeLabel (seg) {
      const dayStr = this.selectedDay.format('YYYY-MM-DD')
      const startsToday = seg.startDate === dayStr
      const endsToday = seg.endDate === dayStr
      if (startsToday && endsToday) return `${seg.startTime} – ${seg.endTime}`
      if (startsToday && !endsToday) return `${seg.startTime} → ${moment(seg.endDate).format('D MMM')} ${seg.endTime}`
      if (!startsToday && endsToday) return `${moment(seg.startDate).format('D MMM')} ${seg.startTime} → ${seg.endTime}`
      return `${moment(seg.startDate).format('D MMM')} ${seg.startTime} → ${moment(seg.endDate).format('D MMM')} ${seg.endTime}`
    },

    restoreFilters () {
      try {
        const saved = JSON.parse(sessionStorage.getItem(FILTERS_STORAGE_KEY))
        if (!saved) return
        this.selectedLocations = Array.isArray(saved.selectedLocations) ? saved.selectedLocations : []
        this.selectedDestinations = Array.isArray(saved.selectedDestinations) ? saved.selectedDestinations : []
        this.filterActive = !!saved.filterActive
        this.filterInactive = !!saved.filterInactive
        this.filterProtected = saved.filterProtected || 'Todos'
        this.searchQuery = saved.searchQuery || ''
        this.quickFilter = saved.quickFilter ?? null
        this.filterStatus = saved.filterStatus || null
      } catch (e) {
        sessionStorage.removeItem(FILTERS_STORAGE_KEY)
      }
    }
  },

  watch: {
    filterState: {
      deep: true,
      handler (val) {
        sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(val))
      }
    }
  },

  created () {
    this.restoreFilters()
    this.loadVehicles()
    this.loadLocations()
  }
}
</script>

<style scoped lang="scss">
// ─────────────────────────────────────────────
// CARD CONTAINER
// ─────────────────────────────────────────────
.planer-card {
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 130px);
  min-height: 400px;
  isolation: isolate;
}

// ─────────────────────────────────────────────
// TOOLBAR: DATE NAV & RANGE TOGGLE
// ─────────────────────────────────────────────
.planer-toolbar {
  background: #2196f3;
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 48px;
  flex-shrink: 0;

  &__title {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    white-space: nowrap;
  }
}
.planer-date-nav {
  display: flex;
  align-items: center;
  gap: 6px;

  &__btn {
    width: 26px;
    height: 26px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.12s;

    .v-icon { color: #fff !important; }
    &:hover { background: rgba(255, 255, 255, 0.22); }
  }

  &__label {
    font-size: 13px;
    font-weight: 500;
    color: #fff;
    min-width: 168px;
    text-align: center;
    white-space: nowrap;
  }

  &__today {
    height: 26px;
    padding: 0 10px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.12s;

    &:hover { background: rgba(255, 255, 255, 0.26); }
  }
}

.planer-range-toggle {
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  overflow: hidden;

  &__btn {
    height: 26px;
    padding: 0 12px;
    border: none;
    background: transparent;
    color: rgba(255, 255, 255, 0.75);
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.12s, color 0.12s;

    &--left { border-right: 1px solid rgba(255, 255, 255, 0.4); }

    &--active {
      background: rgba(255, 255, 255, 0.22);
      color: #fff;
    }
  }
}

// ─────────────────────────────────────────────
// FILTER BAR
// ─────────────────────────────────────────────
.planer-filters {
  flex-shrink: 0;
  background: #fff;
  border-bottom: 0.5px solid #E0E0E0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  flex-wrap: wrap;

  &__dropdown {
    height: 30px;
    padding: 0 10px;
    border: 1px solid #E0E0E0;
    border-radius: 6px;
    background: #fff;
    font-size: 12px;
    color: #424242;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    transition: border-color 0.12s;
    white-space: nowrap;

    &:hover { border-color: #1976D2; }
  }

  &__badge {
    background: #1976D2;
    color: #fff;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 600;
    padding: 1px 6px;
    line-height: 1.4;
  }

  &__menu-item {
    min-height: 32px !important;
  }

  &__chip-group {
    display: flex;
    gap: 4px;
  }

  &__chip {
    height: 26px;
    padding: 0 10px;
    border-radius: 13px;
    border: 1px solid #E0E0E0;
    background: #fff;
    font-size: 11px;
    color: #616161;
    cursor: pointer;
    transition: all 0.12s;

    &--blue { border-color: #1976D2; background: #E3F2FD; color: #1976D2; }
    &--red  { border-color: #EF5350; background: #FFEBEE; color: #EF5350; }
    &--selected { border-color: #1976D2; background: #1976D2; color: #fff; }
  }

  &__search {
    display: flex;
    align-items: center;
    border: 1px solid #E0E0E0;
    border-radius: 6px;
    padding: 0 8px;
    height: 30px;
    background: #fff;
    gap: 4px;
    min-width: 180px;

    &:focus-within { border-color: #1976D2; }
  }

  &__search-icon { flex-shrink: 0; }

  &__search-input {
    border: none;
    outline: none;
    font-size: 12px;
    color: #424242;
    width: 100%;
    background: transparent;

    &::placeholder { color: #BDBDBD; }
  }
}

// ─────────────────────────────────────────────
// LEGEND BAR
// ─────────────────────────────────────────────
.planer-legend {
  flex-shrink: 0;
  background: #FAFAFA;
  border-bottom: 0.5px solid #EEEEEE;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 16px;
  font-size: 10px;
  color: #757575;

  &__item {
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__type-badge {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.08);
    font-size: 8px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;

    &--m { color: #1976D2; }
    &--c { color: #9575CD; }
  }

  &__sep {
    width: 1px;
    height: 14px;
    background: #E0E0E0;
  }
}

// ─────────────────────────────────────────────
// GANTT GRID
// ─────────────────────────────────────────────
.planer-grid {
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
  background: #fff;
  min-height: 0;

  &__header {
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    width: max-content;
    min-width: 100%;
    background: #fff;
    border-bottom: 1px solid #E0E0E0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  }

  &__vehicle-header {
    width: 230px;
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 600;
    color: #9E9E9E;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    border-right: 1px solid #E0E0E0;
    background: #fff;
    position: sticky;
    left: 0;
    z-index: 3;
  }

  &__days-header {
    flex: 1;
    display: flex;
  }

  &__day-col {
    display: flex;
    flex-direction: column;
    border-right: 1px solid #EEEEEE;
    position: relative;
    transition: flex-basis 0.18s ease;

    &--today {
      background: #1565C0;
      .planer-grid__day-num,
      .planer-grid__day-name,
      .planer-grid__tick-label { color: #fff !important; }
      .planer-grid__day-btn .v-icon { color: rgba(255, 255, 255, 0.85) !important; }
      .planer-grid__day-btn:hover { background: rgba(255, 255, 255, 0.18); }
    }

    &--weekend { background: #F5F5F5; }

    &--expanded {
      border-left: 2px solid #1976D2;
      border-right: 2px solid #1976D2;

      .planer-grid__day-actions { opacity: 1; }
    }

    &:hover .planer-grid__day-actions { opacity: 1; }
  }

  &__day-actions {
    position: absolute;
    top: 4px;
    right: 4px;
    display: flex;
    gap: 2px;
    opacity: 0.35;
    transition: opacity 0.12s;
    z-index: 1;
  }

  &__day-btn {
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 4px;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.12s;

    .v-icon { color: #757575 !important; }

    &:hover {
      background: rgba(0, 0, 0, 0.06);
    }
  }

  &__day-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 6px 0 3px;
  }

  &__day-num {
    font-size: 20px;
    font-weight: 700;
    color: #212121;
    line-height: 1;
  }

  &__day-name {
    font-size: 12px;
    color: #9E9E9E;
    line-height: 1;
    margin-top: 2px;
  }

  &__day-ticks {
    position: relative;
    height: 18px;
    width: 100%;
    border-top: 1px dashed #EEEEEE;
    overflow: hidden;
  }

  &__tick {
    position: absolute;
    top: 0;
    height: 100%;
    border-left: 1px dashed #EEEEEE;
    opacity: 0.7;
    transform: translateX(-50%);

    &--end .planer-grid__tick-label {
      left: auto;
      right: 3px;
    }
  }

  &__tick-label {
    position: absolute;
    top: 3px;
    left: 3px;
    font-size: 10px;
    color: #BDBDBD;
    line-height: 1;
    white-space: nowrap;
  }

  // Vehicle rows
  &__row {
    display: flex;
    width: max-content;
    min-width: 100%;
    border-bottom: 1px solid #F0F0F0;
    min-height: 120px;

    &:hover { background: #FAFAFA; }
  }

  &__vehicle-col {
    width: 230px;
    flex-shrink: 0;
    border-right: 1px solid #E8E8E8;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    background: #fff;
    position: sticky;
    left: 0;
    z-index: 1;
  }

  &__days-area {
    flex: 1;
    position: relative;
    min-height: 120px;
    overflow: hidden;
  }

  &__day-bg {
    position: absolute;
    top: 0;
    bottom: 0;

    &--today { background: rgba(21, 101, 192, 0.04); }
    &--weekend { background: #FAFAFA; }
    &--expanded {
      border-left: 2px solid rgba(25, 118, 210, 0.35);
      border-right: 2px solid rgba(25, 118, 210, 0.35);
      background: rgba(25, 118, 210, 0.03);
    }
  }

  &__load-more {
    display: none;
  }

  &__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px;
    color: #BDBDBD;
    font-size: 13px;
    gap: 8px;
  }
}

// ─────────────────────────────────────────────
// VEHICLE CARD
// ─────────────────────────────────────────────
.vc-name {
  font-size: 15px;
  font-weight: 700;
  color: #212121;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vc-plate {
  font-size: 12px;
  font-family: 'Roboto Mono', monospace;
  color: #9E9E9E;
  letter-spacing: 0.5px;
}

.vc-location {
  font-size: 12px;
  color: #9E9E9E;
  display: flex;
  align-items: center;
  gap: 2px;
}

.vc-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 1px;
}

.vc-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 4px;
  line-height: 1.5;
  white-space: nowrap;

  &--active   { background: #E8F5E9; color: #2E7D32; }
  &--inactive { background: #FFEBEE; color: #C62828; }
  &--protected{ background: #FFF3E0; color: #E65100; }
  &--destination { background: #EDE7F6; color: #6A1B9A; }
  &--pending  { background: #FFF3E0; color: #E65100; }
  &--archived { background: #F5F5F5; color: #757575; }
}

.vc-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin-top: 2px;
}

.vc-btn {
  flex: 1 1 45%;
  height: 24px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: filter 0.12s;
  white-space: nowrap;

  &:hover { filter: brightness(0.93); }

  &--movement { background: #E3F2FD; color: #1565C0; }
  &--cession  { background: #EDE7F6; color: #6A1B9A; }
  &--recepcionar { background: #E8F5E9; color: #2E7D32; }
  &--archive  { background: #FFF3E0; color: #E65100; }
}

// ─────────────────────────────────────────────
// GANTT BARS
// ─────────────────────────────────────────────
.planer-bar {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 52px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  cursor: pointer;
  overflow: visible;
  min-width: 4px;
  transition: filter 0.12s, box-shadow 0.12s;

  &:hover {
    filter: brightness(0.91);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    z-index: 5;
  }

  &__type {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.28);
    font-size: 11px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: 6px;

    &--m { color: #1565C0; }
    &--c { color: #6A1B9A; }
  }

  &__label {
    font-size: 12px;
    color: #fff;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 4px;
    flex: 1;
    min-width: 0;
  }

  &__time {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.85);
    margin-right: 4px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  &__check {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.6);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 4px;
    transition: background 0.12s;

    &:hover { background: rgba(255, 255, 255, 0.85); }
  }

  &__connector {
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    pointer-events: none;
  }
}

// ─────────────────────────────────────────────
// MOVEMENT DETAIL DIALOG
// ─────────────────────────────────────────────
.planer-detail {
  border-radius: 8px;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 14px 14px 16px;
    gap: 10px;
  }

  &__header-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  &__type-badge {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &--m { color: #1565C0; }
    &--c { color: #6A1B9A; }
  }

  &__header-label {
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    line-height: 1.2;
  }

  &__header-vehicle {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.8);
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__rows {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 13px;
    color: #424242;

    .v-icon { margin-top: 1px; flex-shrink: 0; }

    &--obs { align-items: flex-start; }
  }

  &__row-label {
    color: #9E9E9E;
    width: 96px;
    flex-shrink: 0;
    font-size: 12px;
  }

  &__row-value {
    flex: 1;
    min-width: 0;

    &--obs {
      white-space: pre-wrap;
      word-break: break-word;
      font-size: 12px;
      color: #616161;
    }
  }
}

// ─────────────────────────────────────────────
// DAY DETAIL DIALOG
// ─────────────────────────────────────────────
.planer-day-detail {
  border-radius: 8px;
  overflow: hidden;

  &__header {
    background: #2196f3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px 12px 16px;
    gap: 10px;
  }

  &__header-left {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  &__title {
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    line-height: 1.2;
  }

  &__subtitle {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.8);
    margin-top: 2px;
  }

  &__stats {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 8px 16px;
    background: #FAFAFA;
    border-bottom: 0.5px solid #EEEEEE;
    font-size: 11px;
    color: #616161;
  }

  &__stat {
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;

    strong { color: #212121; }
  }

  &__stat-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 36px;
    color: #BDBDBD;
    font-size: 13px;
    gap: 8px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px 10px 0;
    border-bottom: 1px solid #F0F0F0;
    cursor: pointer;
    transition: background 0.12s;

    &:hover { background: #FAFAFA; }
    &:last-child { border-bottom: none; }
  }

  &__item-bar {
    width: 4px;
    align-self: stretch;
    border-radius: 0 2px 2px 0;
    flex-shrink: 0;
  }

  &__item-type {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-size: 11px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &--m { background: #E3F2FD; color: #1565C0; }
    &--c { background: #EDE7F6; color: #6A1B9A; }
  }

  &__item-info {
    flex: 1;
    min-width: 0;
  }

  &__item-vehicle {
    font-size: 13px;
    font-weight: 600;
    color: #212121;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__item-plate {
    font-size: 11px;
    font-weight: 400;
    font-family: 'Roboto Mono', monospace;
    color: #9E9E9E;
    margin-left: 6px;
  }

  &__item-time {
    font-size: 11px;
    color: #757575;
    display: flex;
    align-items: center;
    gap: 3px;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__item-transport {
    color: #9E9E9E;
  }

  &__item-status {
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
  }
}

// ─────────────────────────────────────────────
// PAGINATION ROW
// ─────────────────────────────────────────────
.planer-pagination {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px 16px;
  background: #FAFAFA;
  border-top: 0.5px solid #EEEEEE;
  font-size: 12px;
  color: #616161;

  &__left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__label {
    white-space: nowrap;
    color: #616161;
  }

  &__select {
    width: 80px;
    :deep(.v-input__slot) {
      min-height: 32px !important;
    }
    :deep(.v-select__selection--comma) {
      font-size: 12px;
    }
  }

  &__component {
    :deep(.v-pagination__item) {
      font-size: 12px;
      min-width: 30px;
      height: 30px;
    }
    :deep(.v-pagination__navigation) {
      font-size: 12px;
      min-width: 30px;
      height: 30px;
    }
  }

  &__info {
    white-space: nowrap;
    color: #616161;
  }
}

// ─────────────────────────────────────────────
// STATS BAR
// ─────────────────────────────────────────────
.planer-stats {
  flex-shrink: 0;
  height: 40px;
  background: #fff;
  border-top: 0.5px solid #E0E0E0;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 14px;
  font-size: 11px;
  color: #616161;

  &__sep {
    width: 1px;
    height: 16px;
    background: #E0E0E0;
    flex-shrink: 0;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;

    strong { color: #212121; }
  }

  &__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
  }
}
</style>
